<script setup lang="ts">
import { useI18n } from "~/composables/useI18n";

const t = useI18n();
const printRoute = "/resume/download";

function downloadResume() {
  window.open(printRoute, "_blank", "noopener,noreferrer");
}

function shareResume() {
  if (navigator.share) {
    navigator
      .share({
        url: window.location.origin + printRoute,
      })
      .catch((_error) => {
        downloadResume();
      });
  } else {
    downloadResume();
  }
}
</script>
<template>
  <UiButtonGroup>
    <UiButton
      id="download-resume"
      download="Diego_Martin_Marmol-CV.pdf"
      variant="solid"
      class="flex justify-center w-full"
      @click="downloadResume"
    >
      <UIcon
        name="i-custom-download-outline"
        class="mr-2"
        :size="18"
        mode="svg"
      />
      {{ t("downloadResume.buttonLabel") }}
    </UiButton>
    <UiButton @click="shareResume">{{
      t("downloadResume.shareLabel")
    }}</UiButton>
  </UiButtonGroup>
</template>
